<ng-multiselect-dropdown
    [placeholder]="placeholder"
    [settings]="dropdownSettings"
    [data]="dataList"
    [disabled]="disabled"
    [(ngModel)]="selectedItems"
    (ngModelChange)="getSelectedItems()"
></ng-multiselect-dropdown>
